export default {"src":"/_next/static/media/stethoscope_40.129dde0e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};